import React, { useEffect, useState } from "react";
import { backEndBaseUrl } from "../../service/apiSlice";
import Pusher from "pusher-js";
import UserMenu from "./userMenu";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/authSlice";

const LoggedIn = () => {
  const [notify, setNotify] = useState(0);
  const { firstName, lastName, avatar, _id, userType } =
    useSelector(selectUser);

  const userAvatar = avatar
    ? `${backEndBaseUrl}${avatar}`
    : "defaultAvatar.jpg";

  useEffect(() => {
    if (!_id) return;
    const pusherClient = new Pusher(
      process.env.REACT_APP_PUSHER_REAL_TIME_NOTIFICATION as string,
      {
        cluster: "eu",
      }
    );

    const channel = pusherClient.subscribe(_id);
    channel.bind("pusher:subscription_succeeded", () => {});
    channel.bind("notifications", (data: any) => {
      setNotify((prev) => prev + 1);
    });

    return () => {
      channel.unbind("notifications");
      pusherClient.unsubscribe(_id);
      pusherClient.disconnect();
    };
  }, [_id]);

  const clearNotification = () => {
    setNotify(0);
  };

  // Show user menu only when firstName is available (user data has loaded)
  if (!firstName) {
    return null;
  }

  return (
    <UserMenu
      notification={notify}
      firstName={firstName}
      lastName={lastName}
      userAvatar={userAvatar}
      userType={userType}
      clearNotification={clearNotification}
    />
  );
};

export default LoggedIn;
